export const giCommissionEndpoints = (builder) => ({
    getGICommissions: builder.query({
        query: (args = {}) => {
            const {
                pageNumber = 1,
                pageSize = 10,
                searchTerm = null,
                sortField = 'Product_Category',
                sortOrder = 'ASC',
            } = args;

            return {
                url: '/GeneralInsurance/gi-commissions',
                method: 'POST',
                body: {
                    pageNumber,
                    pageSize,
                    searchTerm
                },
            };
        },
        providesTags: ['GICommission'],
    }),

    getGICommissionDetails: builder.query({
        query: ({ commissionId }) => ({
            url: '/GeneralInsurance/gi-commission-details',
            method: 'GET',
            params: { commissionId },
        }),
        providesTags: (result, error, { commissionId }) => [
            { type: 'GICommission', id: commissionId },
            'GICommission'
        ],
    }),

    saveGICommission: builder.mutation({
        query: (data) => ({
            url: '/GeneralInsurance/save-gi-commission',
            method: 'POST',
            body: { TObject: data },
        }),
        invalidatesTags: ['GICommission'],
    }),

    deleteGICommission: builder.mutation({
        query: (data) => ({
            url: '/GeneralInsurance/delete-gi-commission',
            method: 'POST',
            body: data,
        }),
        invalidatesTags: ['GICommission'],
    }),

    getGICommissionRate: builder.query({
        query: (data) => ({
            url: '/GeneralInsurance/gi-commission-rate',
            method: 'POST',
            body: data,
        }),
        keepUnusedDataFor: 0, // Don't cache — always re-fetch
    }),
});
